exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#jumbo-modal-navbar[data-v-5f6e26ff]{background-color:#eaedf3;color:#38404f;z-index:10;font-size:20px;font-weight:600;min-height:50px}#jumbo-modal-navbar .back-button[data-v-5f6e26ff]{background-color:#eaedf3;color:#38404f;height:100%}#jumbo-modal-navbar .back-button[data-v-5f6e26ff]:active,#jumbo-modal-navbar .back-button[data-v-5f6e26ff]:hover{background:#35495e}#jumbo-modal-navbar .title[data-v-5f6e26ff]{font-weight:700;text-align:left;white-space:nowrap}", ""]);

// exports
